import AssignInitiatorToLeadPartyRequest from "../../service/request/AssignInitiatorToLeadPartyRequest";
import LeadPartyApi from "../../service/LeadPartyService";

export default {
  name: "AssignProcessDialog",
  props: {
    processId: {
      type: String,
      required: true
    }
  },
  mixins: [],
  data: function() {
    return {
      isAssignmentInProgress: false
    };
  },
  created() {
    this.show = true;
  },
  methods: {
    onClickAssignProcess() {
      const assigneeId = this.$store.getters["user"].id;
      this.isAssignmentInProgress = true;

      const assignInitiatorToLeadPartyRequest = new AssignInitiatorToLeadPartyRequest();
      assignInitiatorToLeadPartyRequest.assigneeId = assigneeId;

      LeadPartyApi.assignInitiator(
        this,
        this.processId, // We might need to call getmyactivetask and retrieve the response.activeResourceTask.processId and use it here.
        assignInitiatorToLeadPartyRequest,
        () => {
          this.isAssignmentInProgress = false;
          this.$router.push({
            name: "AuthAndVideoCall"
          });
        },
        error => {
          console.log(error);
          this.isAssignmentInProgress = false;
        }
      );
    },
    onClickCancel() {
      this.$emit("onCloseAssignProcessDialog");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/AssignProcessDialog.js